import { FAQ_ITEMS, HOW_TO_STEPS } from '../../data/faq';
import {
  DEFAULT_META,
  OG_IMAGE_URL,
  PIXELUTILITY_URL,
  SITE_NAME,
  SITE_URL,
} from '../../constants';

const ORG_ID = `${SITE_URL}/#organization`;

export function HomeStructuredData() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': ORG_ID,
    name: 'PixelUtility',
    url: PIXELUTILITY_URL,
    logo: `${SITE_URL}/logo192.png`,
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    name: SITE_NAME,
    url: SITE_URL,
    description: DEFAULT_META.description,
    inLanguage: 'en-US',
    publisher: { '@id': ORG_ID },
  };

  const webAppSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    '@id': `${SITE_URL}/#app`,
    name: 'PixelUtility QR Code Generator',
    url: SITE_URL,
    description: DEFAULT_META.description,
    applicationCategory: 'UtilityApplication',
    operatingSystem: 'Any',
    browserRequirements: 'Requires JavaScript',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
    },
    featureList: [
      'Free QR code generation',
      'URL, text, email, call, SMS, vCard, and WiFi QR codes',
      'Custom colors, dot styles, frames, and logo',
      'PNG and SVG download',
      'No sign-up required',
      'Client-side generation in the browser',
      'No redirect tracking pages',
    ],
    screenshot: OG_IMAGE_URL,
    provider: { '@id': ORG_ID },
  };

  const howToSchema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'How to generate a QR code with PixelUtility',
    description: 'Create and download a custom QR code in three steps.',
    step: HOW_TO_STEPS.map((step, index) => ({
      '@type': 'HowToStep',
      position: index + 1,
      name: step.name,
      text: step.text,
    })),
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQ_ITEMS.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'QR Code Generator',
        item: SITE_URL,
      },
    ],
  };

  const schemas = [
    organizationSchema,
    websiteSchema,
    webAppSchema,
    howToSchema,
    faqSchema,
    breadcrumbSchema,
  ];

  return (
    <>
      {schemas.map((schema) => (
        <script
          key={schema['@type']}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
